<template>
    <div class="cardContainer"
        :style="{ borderColor: activityStatus == 1 ? '#36d836' : activityStatus == 2 ? '#ff0000' : '' }">
        <van-row v-if="isShowDetails" :style="{ borderBottom: isShowDetails ? '#80808070 dashed 2px' : '' }">
            <van-col span="6" class="dayColumn">
                <div class="dayImage">
                    <img src="@/assets/common/calender.png" alt="">
                    <div class="dateText">{{ createTime?.split(' ')[0] }}
                    </div>
                </div>
            </van-col>
            <van-col span="8" class="topRow" style="margin: 10px 0; border-left: 2px solid #80808070;">
                <div class="dayTitle">{{ title }}</div>
                <div class="valueText">{{ formatCurrency(totalAmount) }}</div>
            </van-col>
            <van-col span="8" class="topRow" style="margin: 10px 0;">
                <div class="dayTitle">{{ $t('activity.cashBackTotal') }}</div>
                <div class="valueText">{{ dayList ? formatCurrency(getAmountSum(dayList)) : formatCurrency(0) }}</div>
            </van-col>
        </van-row>

        <van-row v-if="!isShowDetails" :style="{ borderBottom: isShowDetails ? '#80808070 dashed 2px' : '' }">
            <van-col span="6" class="dayColumn">
                <div class="dayImage2">
                    <img src="@/assets/common/calender.png" alt="">
                    <div class="dateText" style="font-size: 12px;">{{ createTime?.split(' ')[0] }}
                    </div>
                </div>
            </van-col>
            <van-col span="12" class="topRow" style="margin: 10px 0;">
                <div class="dayTitle" style="font-size: 12px;">{{ $t('activity.givenAmount') }} : <span
                        style="padding-left: 10px;"> {{ formatCurrency(givenAmount) }}</span></div>
            </van-col>
            <van-col span="6" class="dayColumn">
                <span class="right-texts">
                    <p v-if="props.activityStatus == 0" style="color: #0484ff;">{{
                        $t('activityStatus.pending') }}</p>
                    <p v-else-if="props.activityStatus == 1" style="color: #36d836;">{{ $t('activityStatus.completed')
                    }}</p>
                    <p v-else-if="props.activityStatus == 2" style="color: #ff0000;">{{ $t('activityStatus.noRewards')
                    }}</p>
                    <p v-else-if="props.activityStatus == 3" style="color: #ff0000;">{{ $t('activity.overdue')
                    }}</p>
                </span>
            </van-col>
        </van-row>
        <van-row v-if="isShowDetails" style="margin-top: 10px; display: flex; justify-content: center;"
            justify="space-between">
            <van-col span="4" v-for="(i, index) in dayList" :key="index">
                <div class="dayCard"
                    :style="{ color: checkDate(i.date) == 0 && istodayClaimed ? '#36d836' : checkDate(i.date) <= 0 ? 'gray' : '' }">
                    <div class="dayTitle">{{ (dayFormat(i.date, 0)) }}</div>
                    <div>{{ formatCurrency(i.amount) }}</div>
                </div>
            </van-col>{{ }}
            <van-col v-if="dayList?.length <= 0 || !dayList">
                <p v-if="props.activityStatus == 0" style="color: #0484ff;">{{
                    $t('activityStatus.pending') }}</p>
                <p v-else-if="props.activityStatus == 1" style="color: #36d836;">{{ $t('activityStatus.completed')
                    }}</p>
                <p v-else-if="props.activityStatus == 2" style="color: #ff0000;">{{ $t('activityStatus.noRewards')
                    }}</p>
                <p v-else-if="props.activityStatus == 3" style="color: #ff0000;">{{ $t('activity.overdue')
                    }}</p>
            </van-col>
        </van-row>
    </div>
</template>
<script lang="ts" setup>
import { checkDate, dayFormat, formatCurrency, } from '@/utils/commonFunction';
import { getAmountSum } from '@/view/components/supportFunction';
import { defineProps, PropType, } from 'vue';

const props = defineProps({
    dayCount: {
        type: Number,
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    createTime: {
        type: String,
        default: () => ""
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    title: {
        type: String,
        default: () => ""
    },
    totalAmount: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    isShowDetails: {
        type: Boolean,
        default: () => true
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
})

</script>
<style scoped>
.cardContainer {
    background: #292a2d;
    border: 2px solid #ffcea6;
    border-radius: 10px;
    padding: 10px 5px;
    color: #fff;
    font-size: 12px;
    margin: 10px 0 0;
}

.topRow {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.dayColumn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.right-texts {
    text-align: center;
    display: flex;
}

.day-num {
    position: absolute;
    font-size: 20px;
    white-space: nowrap;
    color: #FFF5D7;
    text-shadow: -1px -1px 0 #300000, 1px -1px 0 #300000, -1px 1px 0 #300000, 1px 1px 0 #300000;
    z-index: 800;
    font-weight: 700;
    left: 55%;
    top: 25%;
}

.dateText {
    position: absolute;
    top: 50%;
    padding: 5px 0;
    font-size: 6px;
    color: #000;
    font-weight: 600;
}

.dayImage img {
    width: 80%;
    padding: 0 0 5px;
    position: relative;
}

.dayImage {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.dayImage2 img {
    width: 75px;
    height: 50px;
    position: relative;
}

.dayImage2 {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.centerAlignment {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.dayCard {
    color: #fff;
    font-size: 9.5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 5px 0;
    min-width: 13%;
    flex-shrink: 0;
}

.dayCardWrapper {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    flex: 1;
}

.dayCardWrapper::-webkit-scrollbar {
    display: none;
}

.scrollRow {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    gap: 5px;
}

.arrowLeft img {
    width: 10px;
}

.arrowRight {
    position: absolute;
    right: 0px;
}

.arrowLeft {
    position: absolute;
    left: 0px;
}

.arrowRight img {
    width: 10px;
    transform: rotate(180deg);
}

.dayTitle {
    font-weight: bold;
    padding-bottom: 5px;
}

.rightBorder {
    border-right: 1px solid #80808070;
}

.click_btn {
    color: #12151A;
    font-size: 11.5px;
    background-image: linear-gradient(rgb(248, 216, 167) 0%, rgb(240, 168, 83) 100%);
    border-radius: 5px;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 50%;
}

.valueText {
    padding: 2px 0 5px;
}

.bottomDayRow {
    display: flex;
    flex-direction: row;
}

@media (min-width:350px) {
    .dateText {
        font-size: 8px;
    }
}

@media (min-width:450px) {
    .dateText {
        font-size: 11px;
    }
}

@media (min-width: 600px) {
    .dateText {
        font-size: 10px;
    }
}

@media (min-width: 1920px) {
    .dateText {
        font-size: 14px;
    }
}
</style>